<template>
  <div class="share-campaign-modal">
    <div class="share-campaign-modal-content">
      <div class="div-block-169">
        <div>
          <h1 class="heading-25">Share unique link</h1>
        </div>
        <div class="div-block-170-profile">
          <div class="w-layout-grid grid-4">
            <a :href="twitterLink" class="link-block-13-profile w-inline-block">
              <img
                src="@/assets/timeslot-images/twitter_1.svg"
                loading="lazy"
                alt=""
                class="image-39"
              />
              <div class="text-block-98">Twitter</div>
            </a>
            <a :href="facebookLink" class="link-block-13-profile w-inline-block"
              ><img
                src="https://uploads-ssl.webflow.com/62dfacded1d3f8f862adb3ad/62dfacded1d3f8443dadb41d_Facebook.svg"
                loading="lazy"
                alt=""
                class="image-39"
              />
              <div class="text-block-98">Facebook</div>
            </a>
            <a :href="mailLink" class="link-block-13-profile w-inline-block"
              ><img
                src="@/assets/timeslot-images/Mail.svg"
                loading="lazy"
                alt=""
                class="image-39"
              />
              <div class="text-block-98">Mail</div>
            </a>
            <a :href="whatsappLink" class="link-block-13-profile w-inline-block"
              ><img
                src="@/assets/timeslot-images/whatsapp_1.svg"
                loading="lazy"
                alt=""
                class="image-39"
              />
              <div class="text-block-98">WhatsApp</div>
            </a>
            <a :href="telegramLink" class="link-block-13-profile w-inline-block"
              ><img
                src="@/assets/timeslot-images/Telegram_1.svg"
                loading="lazy"
                alt=""
                class="image-39"
              />
              <div class="text-block-98">Telegram</div>
            </a>
            <!--            <a href="#" class="link-block-13-profile w-inline-block"-->
            <!--              ><img-->
            <!--                src="@/assets/timeslot-images/linkedin-1.svg"-->
            <!--                loading="lazy"-->
            <!--                alt=""-->
            <!--                class="image-39"-->
            <!--              />-->
            <!--&lt;!&ndash;              src="@/assets/timeslot-images/Group-34126.svg"&ndash;&gt;-->
            <!--              <div class="text-block-98">LinkedIn</div>-->
            <!--            </a>-->
          </div>
        </div>
        <div>
          <div class="text-block-95-profile">Unique link</div>
          <div class="div-block-171">
            <div class="link-container">
              <div class="text-block-97-profile" id="link-text">
                app.timeslate.com/{{ singleProfessional.professionalId }}/{{
                  singleProfessional.professionalReference
                }}
              </div>
              <!--              <FormulateInput id="profile-link-container" type="text" :value="profRef"/>-->
            </div>
            <div class="clip-container">
              <a
                href="#"
                class="w-inline-block"
                title="Copy"
                v-clipboard:copy="profRef"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <img
                  src="@/assets/timeslot-images/Copy_2.svg"
                  loading="lazy"
                  alt=""
                />

                <!--                <p v-else>Copied!</p>-->
              </a>
            </div>
            <!--            <div class="text-block-97-profile">www.timeslate.com/{{ singleProfessional.professionalReference }}</div>-->
          </div>
        </div>
      </div>
      <div
        data-w-id="0e67515a-ddda-426c-eef9-0a19697e5e28"
        @click="cancel"
        class="link-block-10-copy-profile w-inline-block"
      >
        <img
          src="@/assets/timeslot-images/Group-36561.svg"
          loading="lazy"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import NotificationUtils from "@/utils/BaseUtils/NotificationUtils";

// let text = document.getElementById('link-text').innerHTML;
// const copyContent = async () => {
//   try {
//     await navigator.clipboard.writeText(text);
//     console.log('Content copied to clipboard');
//   } catch (err) {
//     console.error('Failed to copy: ', err);
//   }
// }

export default {
  name: "ShareProfileModal",
  data() {
    return {
      isCopied: false
    };
  },
  computed: {
    ...mapState({
      singleProfessional: state => state.professional.singleProfessional
    }),
    profRef() {
      return `app.timeslate.com/professionals/${this.singleProfessional.professionalId}/${this.singleProfessional.professionalReference}`;
    },
    twitterLink() {
      return `https://twitter.com/intent/tweet?text=Check%20out%20my%20profile%20on%20Timeslate%0A%0A${this.profRef}`;
    },
    facebookLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.profRef}`;
    },
    whatsappLink() {
      return `whatsapp://send?text=Check%20out%20my%20profile%20on%20*Timeslate*%0A%0A${this.profRef}`;
    },
    telegramLink() {
      return `https://telegram.me/share/url?url=${this.profRef}&text=Check%20out%20my%20profile%20on%20Timeslate`;
    },
    mailLink() {
      return `mailto:?subject=Check%40out%40my%40profile%40on%40Timeslate&body=Please%40check%40out%40my%40profile%40on%40Timeslate%3A${this.profRef}`;
    }
  },
  props: {
    cancel: Function
  },
  methods: {
    onCopy: function(e) {
      // alert("You just copied: " + e.text);
      // StoreUtils.dispatch(
      //     StoreUtils.actions.notification.addNotificationSlide,
      //     e
      // );
      NotificationUtils.addNotificationSlide(
        "Copied!",
        NotificationUtils.type.SUCCESS
      );
      // this.isCopied = true;
    },
    onError: function(e) {
      alert("Failed to copy texts");
    }
  }
};
</script>

<style scoped>
.link-container {
  width: 90%;
}
.clip-container {
  /*width: 5%;*/
}
</style>
